module.exports = __webpack_public_path__ + "img/payBack.95009853.png";